(function () {
  function collectionSearchHasActiveFilters(searchParamsOverride) {
    var raw =
      searchParamsOverride != null && String(searchParamsOverride).length
        ? String(searchParamsOverride)
        : window.location.search.slice(1);
    var params = new URLSearchParams(raw);
    var hasActive = false;
    params.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0 && String(value).trim() !== '') {
        hasActive = true;
      }
    });
    return hasActive;
  }

  function syncDiscountBannerFilterVisibility(event) {
    var override = event && event.detail && event.detail.searchParams;
    var filtered = collectionSearchHasActiveFilters(override);
    document.querySelectorAll('[data-storefront-discount-banner="true"]').forEach(function (root) {
      root.hidden = filtered;
    });
  }

  function bindDismiss(root) {
    if (!root || root.getAttribute('data-storefront-discount-banner') !== 'true') return;
    var key = root.getAttribute('data-storage-key');
    var btn = root.querySelector('[data-storefront-discount-dismiss]');
    if (!btn || !key) return;
    if (btn.getAttribute('data-storefront-discount-bound') === 'true') return;
    btn.setAttribute('data-storefront-discount-bound', 'true');
    btn.addEventListener('click', function () {
      try {
        localStorage.setItem(key, '1');
      } catch (e) {}
      root.remove();
    });
  }

  /** Remove dismissed banners and attach dismiss handlers (e.g. after facets replace #ProductGridContainer). */
  function syncDiscountBanners(event) {
    document.querySelectorAll('[data-storefront-discount-banner="true"]').forEach(function (root) {
      var key = root.getAttribute('data-storage-key');
      try {
        if (key && localStorage.getItem(key) === '1') {
          root.remove();
          return;
        }
      } catch (e) {}
      bindDismiss(root);
    });
    syncDiscountBannerFilterVisibility(event);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncDiscountBanners);
  } else {
    syncDiscountBanners();
  }

  document.addEventListener('product-grid:updated', syncDiscountBanners);
  window.addEventListener('popstate', syncDiscountBannerFilterVisibility);
})();
